var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-lg-10 col-md-8 col-12 main"},_vm._l((_vm.list),function(item,index){return _c('img',{key:index,staticStyle:{"width":"100%","margin-bottom":"0px"},attrs:{"src":item.img,"alt":item.alt}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }